export const TYPE_OF_PAGE = {
  MAIN: 'main',
  USER_DETAILS: 'userDetailsPage'
};
